import { Box, SubTitle, Title } from 'vopay';
import ChangePasswordForm from './ChangePasswordForm';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';
import { useTranslation } from 'react-i18next';

const UserProfile = () => {
  const {
    response: { username },
  } = usePartnerLogin();
  const { t } = useTranslation('translations', { keyPrefix: 'UserProfile' });

  return (
    <>
      <Box mb="lg">
        <Title title={t('pageTitle', { username })} />
      </Box>

      <Box flx="col" mb="lg">
        <SubTitle subTitle={t('Password.title')} />
        <SubTitle variant="small" subTitle={t('Password.subTitle')} />
      </Box>
      <ChangePasswordForm />
    </>
  );
};

export default UserProfile;
